module.exports = __webpack_public_path__ + "static/media/font_regular.628181c5.woff2";